/**
 * TELV1-551 — returns null for ANY unreadable token, not just a falsy
 * one. The old version threw on a present-but-malformed token (no '.',
 * bad base64, bad JSON), which crashed callers that only guarded the
 * falsy case. The explicit return type forces callers to handle null —
 * `'x' in payload` on null was a live TypeError
 * (Sentry TELLET-DASHBOARD-5S, 1.4k events).
 */
export const parseJwt = (token: string): Record<string, unknown> | null => {
  if (!token) return null;
  try {
    const base64Url = token.split('.')[1];
    // Explicit guard (not just the catch): a token without dots is the
    // common malformed shape and shouldn't pay the throw/catch path.
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};
